"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldsModal = void 0;
require("./index.scss");
var React = require("react");
var react_redux_1 = require("react-redux");
var ReducerTypes = require("@caddigital/sok-reducers/lib/types");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var ConfirmButton_1 = require("./components/ConfirmButton/ConfirmButton");
var FieldsList_1 = require("./components/FieldsList");
var InfoBox_1 = require("./components/InfoBox");
var InputFields_1 = require("./components/InputFields");
var ContentContainer_1 = require("./components/ContentContainer");
var dispatchers_1 = require("./utils/dispatchers");
var selectedFields_1 = require("./utils/selectedFields");
var timezones_1 = require("utils/helpers/timezones");
var user_1 = require("utils/selectors/user");
var localization_1 = require("./utils/localization");
var reports_1 = require("utils/selectors/reports");
var FieldsModal = function (props) {
    var userLanguage = (0, react_redux_1.useSelector)(user_1.selectUserLanguage);
    var reportLocaleData = (0, react_redux_1.useSelector)(reports_1.selectReportLocaleData);
    var isOpen = (0, react_redux_1.useSelector)(function (state) { return state.reports.fieldsModal.fieldsModalIsOpen; });
    var reportUuid = (0, react_redux_1.useSelector)(function (state) { return state.reports.fieldsModal.reportUuid; });
    var modalMode = (0, react_redux_1.useSelector)(function (state) { return state.reports.fieldsModal.mode; });
    var fetchedReportFields = (0, react_redux_1.useSelector)(function (state) { return state.reports.fields.reportFields; });
    var selectedReport = (0, react_redux_1.useSelector)(function (state) { return state.reports.selectedReport; });
    var reportFieldsFetchingStatus = (0, react_redux_1.useSelector)(function (state) { return state.reports.fields.status; });
    var reportCreationStatus = (0, react_redux_1.useSelector)(function (state) { return state.reports.createReport.status; });
    var reportUpdateStatus = (0, react_redux_1.useSelector)(function (state) { return state.reports.updateReport.status; });
    var reportCreateValidationErrors = (0, react_redux_1.useSelector)(function (state) { return state.reports.createReport.errors; });
    var reportUpdateValidationErrors = (0, react_redux_1.useSelector)(function (state) { return state.reports.updateReport.validationErrors; });
    var _a = React.useState([]), selectedFields = _a[0], setSelectedFields = _a[1];
    var _b = React.useState(''), originalTemplateName = _b[0], setOriginalTemplateName = _b[1];
    var _c = React.useState(''), templateName = _c[0], setTemplateName = _c[1];
    var _d = React.useState(''), templateDescription = _d[0], setTemplateDescription = _d[1];
    var _e = React.useState(), language = _e[0], setLanguage = _e[1];
    var _f = React.useState(), timezone = _f[0], setTimezone = _f[1];
    var _g = React.useState([]), reportTemplateNameValidationErrors = _g[0], setReportTemplateNameValidationErrors = _g[1];
    var reportList = (0, react_redux_1.useSelector)(function (state) { return state.reports.reportList; });
    var localeData = React.useMemo(function () { return ({
        language: language,
        setLanguage: setLanguage,
        timezone: timezone,
        setTimezone: setTimezone
    }); }, [language, setLanguage, timezone, setTimezone]);
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    React.useEffect(function () {
        if (!isOpen) {
            return;
        }
        setLanguage(modalMode === 'VIEW' ? reportLocaleData.language : userLanguage);
        setTimezone(modalMode === 'VIEW' ? reportLocaleData.timezone : (0, timezones_1.getLocalTimezone)());
        dispatchers.fetchReportFields(props.currentCustomer.id);
        return function () {
            dispatchers.clearReportFields();
            dispatchers.clearCreateReportStatus();
            setSelectedFields([]);
            setTemplateName('');
            setTemplateDescription('');
            setReportTemplateNameValidationErrors([]);
            setOriginalTemplateName('');
        };
    }, [isOpen, reportLocaleData.language, reportLocaleData.timezone]);
    React.useEffect(function () {
        if (reportCreationStatus === ReducerTypes.FETCHED)
            handleReportCreationSuccess();
        else if (reportCreationStatus === ReducerTypes.FAILED)
            handleReportCreationFailure();
    }, [reportCreationStatus]);
    React.useEffect(function () {
        if (reportFieldsFetchingStatus === ReducerTypes.FAILED) {
            dispatchers.showFetchingFieldsErrorToast();
        }
    }, [reportFieldsFetchingStatus]);
    React.useEffect(function () {
        if (!isOpen)
            return;
        switch (reportUpdateStatus) {
            case ReducerTypes.FETCHED:
                dispatchers.closeModal();
                dispatchers.showUpdateReportSuccessToast();
                break;
            case ReducerTypes.FAILED:
                dispatchers.showUpdateReportFailureToast();
                break;
        }
    }, [reportUpdateStatus]);
    var validationErrors = reportCreateValidationErrors !== null && reportCreateValidationErrors !== void 0 ? reportCreateValidationErrors : reportUpdateValidationErrors;
    var createReport = function () {
        dispatchers.createReport({
            type: ReducerTypes.REPORT,
            fields: selectedFields.map(function (field) { return field.fieldName; }),
            customerId: props.currentCustomer.id,
            language: language === null || language === void 0 ? void 0 : language.code,
            timezone: timezone === null || timezone === void 0 ? void 0 : timezone.value
        });
    };
    var createOrUpdateReportTemplate = function () {
        if (selectedReport.report === null) {
            dispatchers.createReport({
                type: ReducerTypes.TEMPLATE,
                name: templateName,
                description: templateDescription,
                fields: selectedFields.map(function (field) { return field.fieldName; }),
                customerId: props.currentCustomer.id
            });
            return;
        }
        dispatchers.updateReport(props.currentCustomer.id, selectedReport.report.uuid, {
            name: templateName,
            description: templateDescription,
            fields: selectedFields.map(function (field) { return field.fieldName; })
        });
    };
    React.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (modalMode === 'CREATE') {
            return;
        }
        var currentReportFields = (_b = (_a = selectedReport.report) === null || _a === void 0 ? void 0 : _a.selectedFields) !== null && _b !== void 0 ? _b : [];
        var selected = (0, selectedFields_1.resolveSelectedFields)(currentReportFields, fetchedReportFields);
        setSelectedFields(selected);
        setTemplateName((_d = (_c = selectedReport.report) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '');
        if (modalMode === 'EDIT' &&
            !originalTemplateName &&
            ((_e = selectedReport.report) === null || _e === void 0 ? void 0 : _e.name)) {
            setOriginalTemplateName((_f = selectedReport.report) === null || _f === void 0 ? void 0 : _f.name);
        }
        setTemplateDescription((_h = (_g = selectedReport.report) === null || _g === void 0 ? void 0 : _g.description) !== null && _h !== void 0 ? _h : '');
    }, [selectedReport.report, fetchedReportFields]);
    React.useEffect(function () {
        if (props.listEntryType === ReducerTypes.REPORT) {
            setReportTemplateNameValidationErrors([]);
            return;
        }
        var errorsArray = [];
        var sameNameError = modalMode !== 'VIEW' &&
            reportList.reports.some(function (report) {
                return report.name === templateName && report.name !== originalTemplateName;
            });
        if (sameNameError)
            errorsArray.push('sameNameError');
        if (!templateName)
            errorsArray.push('emptyNameError');
        setReportTemplateNameValidationErrors(errorsArray);
    }, [templateName, isOpen]);
    var isBlockingOperationOngoing = reportFieldsFetchingStatus === ReducerTypes.FETCHING ||
        reportCreationStatus === ReducerTypes.FETCHING ||
        reportUpdateStatus === ReducerTypes.FETCHING;
    var disabledFields = isBlockingOperationOngoing || modalMode === 'VIEW';
    var handleFetchReport = function () {
        return reportUuid !== null &&
            dispatchers.retrieveReport(reportUuid, props.listEntryType);
    };
    var handleReportCreationSuccess = function () {
        dispatchers.closeModal();
        dispatchers.clearCreateReportStatus();
        props.listEntryType === ReducerTypes.REPORT
            ? dispatchers.showReportCreationSuccessToast()
            : dispatchers.showTemplateCreationSuccessToast();
    };
    var handleReportCreationFailure = function () {
        dispatchers.closeModal();
        dispatchers.clearCreateReportStatus();
        props.listEntryType === ReducerTypes.REPORT
            ? dispatchers.showReportCreationErrorToast()
            : dispatchers.showTemplateCreationErrorToast();
    };
    var displayLocaleFields = function () {
        return props.listEntryType === ReducerTypes.REPORT &&
            (modalMode === 'CREATE' ||
                (reportLocaleData.language && reportLocaleData.timezone));
    };
    return (React.createElement(sok_ui_1.Modal, { isOpen: isOpen, className: 'customer-management-report-fields-modal' },
        React.createElement(sok_ui_1.Header, { onClose: dispatchers.closeModal }, (0, localization_1.localizedHeader)(modalMode, props.listEntryType)),
        React.createElement("form", { onSubmit: function (e) {
                e.preventDefault();
            } },
            React.createElement(sok_ui_1.Container, null,
                React.createElement(sok_ui_1.RequestStatusBox, { statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                    (0, translation_1.getLocalization)('management/reports/modal/saving'),
                    (0, translation_1.getLocalization)('management/reports/modal/saved'),
                    (0, translation_1.getLocalization)('management/reports/modal/failed')),
                React.createElement(ContentContainer_1.ContentContainer, { mode: modalMode, status: selectedReport.status, fetch: handleFetchReport },
                    props.listEntryType === ReducerTypes.TEMPLATE && (React.createElement(InputFields_1.InputFields, { name: templateName, description: templateDescription, onNameChange: setTemplateName, onDescriptionChange: setTemplateDescription, validationErrors: validationErrors, reportTemplateNameValidationErrors: reportTemplateNameValidationErrors, disabled: disabledFields })),
                    displayLocaleFields() && (React.createElement(InputFields_1.LocaleFields, { localeData: localeData, disabled: disabledFields })),
                    React.createElement(InfoBox_1.InfoBox, { content: props.listEntryType === ReducerTypes.TEMPLATE
                            ? (0, translation_1.getLocalization)('management/reports/modal/template/info')
                            : (0, translation_1.getLocalization)('management/reports/modal/info') }),
                    React.createElement(FieldsList_1.FieldsList, { fetchedReportFields: fetchedReportFields, selectedFields: selectedFields, setSelectedFields: setSelectedFields, disabled: disabledFields }))),
            React.createElement(sok_ui_1.Footer, null,
                modalMode !== 'VIEW' &&
                    (isBlockingOperationOngoing ? (React.createElement(sok_ui_1.LoadingSpinner, { className: "fields-modal-confirmation-loading-spinner button-group" })) : (React.createElement(ConfirmButton_1.ConfirmButton, { onClick: props.listEntryType === ReducerTypes.TEMPLATE
                            ? createOrUpdateReportTemplate
                            : createReport, listEntryType: props.listEntryType, disabled: selectedFields.length === 0 ||
                            reportTemplateNameValidationErrors.length > 0 }))),
                React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('buttons/close'), iconRight: React.createElement(sok_ui_1.Icon, { className: 'fa-times-circle' }), color: 'dark-gray', onClick: dispatchers.closeModal, disabled: isBlockingOperationOngoing })))));
};
exports.FieldsModal = FieldsModal;
